import { datadogLogs } from '@datadog/browser-logs';
export default function loadDataDog(dataDogClientToken, dataDogservice, environment, jutroversion = "5.3.1", dataDogSite = 'datadoghq.com') {
  datadogLogs.init({
    clientToken: dataDogClientToken,
    site: dataDogSite,
    env: `atmos-${environment}`,
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: jutroversion,
    service: dataDogservice
  });
}